import React from 'react';
import { FiUpload, FiCheck, FiX } from 'react-icons/fi';

const ProgressTracker = ({ progress, type }) => {
  const { current, total, errors } = progress;
  const percentage = total > 0 ? Math.round((current / total) * 100) : 0;
  const isComplete = current === total;

  return (
    <div className="progress-tracker">
      <div className="progress-header">
        <h3>Uploading {type} Records</h3>
        <div className="progress-stats">
          <span className="current-progress">{current} of {total} processed</span>
          <span className="percentage">{percentage}%</span>
        </div>
      </div>

      <div className="progress-bar-container">
        <div className="progress-bar">
          <div
            className="progress-fill"
            style={{ width: `${percentage}%` }}
          ></div>
        </div>
      </div>

      <div className="progress-details">
        <div className="detail-item">
          <FiUpload className="detail-icon" />
          <span>Processing records...</span>
        </div>

        {current > 0 && (
          <div className="detail-item">
            <FiCheck className="detail-icon success" />
            <span>{current - errors.length} records uploaded successfully</span>
          </div>
        )}

        {errors.length > 0 && (
          <div className="detail-item">
            <FiX className="detail-icon error" />
            <span>{errors.length} records failed</span>
          </div>
        )}
      </div>

      {errors.length > 0 && (
        <div className="error-preview">
          <h4>Recent Errors:</h4>
          <div className="error-list">
            {errors.slice(-3).map((error, index) => (
              <div key={index} className="error-item">
                <span className="error-row">Row {error.row}:</span>
                <span className="error-message">{error.error}</span>
              </div>
            ))}
            {errors.length > 3 && (
              <div className="error-more">
                ...and {errors.length - 3} more errors
              </div>
            )}
          </div>
        </div>
      )}

      {isComplete && (
        <div className="completion-message">
          <FiCheck className="completion-icon" />
          <span>Upload process completed!</span>
        </div>
      )}
    </div>
  );
};

export default ProgressTracker;